"use client";

import type { ReactNode } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Accordion from "./ui/Accordion";

export { Accordion };

export function SubPageLayout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-white dark:bg-[#0a0a0a] selection:bg-[#C9A227]/30">
      <Header />

      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] dark:text-white mb-12">
            {title}
          </h1>
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
